import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { FILTER_TYPES } from '../../../../../constants';

import styles from './index.module.css';

export const SingleCategoryItem = ({
  isActive,
  isDisabled,
  categoryData,
  onFilterItemClick
}) => {
  const { t } = useI18n();

  const { logo, nameTranslationKey, id, title } = categoryData;
  return (
    <Box
      className={clsx([
        styles.categoryChip,
        isActive && styles.selectedCategory,
        isDisabled && styles.categoryDisabled
      ])}
      onClick={() => onFilterItemClick(id, FILTER_TYPES.CATEGORIES)}
      key={`${title}-${id}`}
      role="presentation"
    >
      <Box
        className={styles.categoryImgWrapper}
        margin="0 s 0 0"
        align="center"
        justify="center"
      >
        <img className={styles.categoryImg} src={logo} alt="" />
      </Box>
      <AText
        className={styles.categoryName}
        breed="RU"
        size="m"
        align="center"
        color="txt_color_2"
      >
        {t(nameTranslationKey)}
      </AText>
    </Box>
  );
};
